export const PlanType = Object.freeze({
  BASIC: 'basic',
  SORENSON_FREE_TRIAL: 'sorenson_free_trial',
  SORENSON_PROFESSIONAL: 'sorenson_professional',
  SORENSON_CONSUMABLE: 'sorenson_pay_as_you_go'
});

export const BillingType = Object.freeze({
  ONETIME: 'onetime',
  SUBSCRIPTION: 'subscription',
  CONSUMABLE: 'consumable',
});